import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../components/site/Seo";
import NotFound from "./NotFound";

export default function CustomPage() {
  const { slug } = useParams();
  const [p, setP] = useState(undefined);
  useEffect(() => {
    setP(undefined);
    api.get(`/pages/${slug}`).then((r) => setP(r.data)).catch(() => setP(null));
  }, [slug]);
  useSeo({ title: p ? `${p.seo_title || p.title} | Agni Shiksha` : "Agni Shiksha", description: p?.meta_description });
  if (p === undefined) return <div className="container-px py-40 text-center text-content-muted">Loading…</div>;
  if (p === null) return <NotFound />;
  return (
    <div className="container-px section-y max-w-3xl">
      {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full rounded-2xl border border-line mb-8 object-cover" data-testid="page-cover" />}
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight mb-6" data-testid="page-title">{p.title}</h1>
      <article className="prose-invert text-content-secondary leading-relaxed [&_p]:mb-4 [&_img]:rounded-xl [&_img]:my-6 [&_h2]:text-content [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-content [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:mt-6 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_a]:text-ember"
        dangerouslySetInnerHTML={{ __html: p.content || "" }} data-testid="page-content" />
    </div>
  );
}
